import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useCustomToolBuilder } from '../builder/builder-context';
import { InputEditor } from '../steps/input-editor';
import { BLOCK, FOCUSED } from './block';

/** What the AI passes the tool: one input for each argument set to "The AI passes it". */
export const InputsBlock = () => {
	const { draft, focus } = useCustomToolBuilder();
	return (
		<section data-block='inputs' aria-label='The AI passes' className={cn(BLOCK, focus?.kind === 'inputs' ? FOCUSED : 'border-gray-300')}>
			<div className='flex items-start gap-2'>
				<Sparkles className='mt-0.5 size-4 shrink-0 text-sky-600' aria-hidden />
				<div className='flex min-w-0 flex-col'>
					<h2 className='text-[13px] leading-4.5 font-medium text-ink'>The AI passes</h2>
					<p className='text-xs leading-4 text-gray-800'>The AI reads each input’s name and description to know what to pass.</p>
				</div>
			</div>
			{draft.inputs.length === 0 ? (
				<p className='text-xs leading-4 text-gray-800'>No inputs yet. Set an argument below to “The AI passes it” and it shows up here.</p>
			) : (
				<div className='grid gap-3 sm:grid-cols-2'>
					{draft.inputs.map((input, index) => (
						// Rows have no id of their own and the name is what gets edited.
						<div key={index} className='rounded-lg border border-gray-300 p-3'>
							<InputEditor index={index} />
						</div>
					))}
				</div>
			)}
		</section>
	);
};
